import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightRedactionMessage: {
		id: 'issue.redaction.spotlight-redaction-message',
		defaultMessage:
			'The solid bar indicates that your organization detected and deleted sensitive data.',
		description: 'Spotlight message explaining redaction markers',
	},
	spotlightActionMenuMessage: {
		id: 'issue.redaction.spotlight-action-menu-message',
		defaultMessage:
			'Go to Redactions in this menu to view details about the redactions on this issue.',
		description: 'Spotlight message for issue action menu saying where to find redactions',
	},
	next: {
		id: 'issue.redaction.spotlight-next-button',
		defaultMessage: 'Next',
		description: 'Next button text for redaction spotlight',
	},
	ok: {
		id: 'issue.redaction.spotlight-ok-button',
		defaultMessage: 'Ok',
		description: 'Ok button text for redaction spotlight',
	},
	readMore: {
		id: 'issue.redaction.spotlight-read-more-button',
		defaultMessage: 'Read more',
		description: 'Read more button text for redaction spotlight',
	},
	dismiss: {
		id: 'issue.redaction.spotlight-dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button text for redaction spotlight',
	},
	onboardingStep1: {
		id: 'issue-view-redaction.onboarding.onboarding-step-1',
		defaultMessage: '1/2',
		description: 'Step 1/2 of redaction onboarding',
	},
	onboardingStep2: {
		id: 'issue-view-redaction.onboarding.onboarding-step-2',
		defaultMessage: '2/2',
		description: 'Step 2/2 of redaction onboarding',
	},
	spotlightActionMenuMessageIssueTerminologyRefreshM4: {
		id: 'issue.redaction.spotlight-action-menu-message-issue-terminology-refresh-m4',
		defaultMessage:
			'Go to Redactions in this menu to view details about the redactions on this work item.',
		description: 'Spotlight message for issue action menu saying where to find redactions',
	},
});
